export default __webpack_public_path__ + "static/media/Aum Singhal_ Web Design team .f60c3555.jpg";